import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import Model from '../models/model';
import consts from '../consts';
import util from '../util/index';
import strings from "../Globalization/index";
import { dataStore } from '../Store';

const { viewOnly } = util;

const processBarcodeDetail = (event, { formik, activeRecord, value }) => {
	let barcodeScanValue = value;
	let barcodeScannedValueFound = false;
	let scanedValue=''
	try {
		scanedValue = util.parseBarcode(barcodeScanValue);
		barcodeScannedValueFound = scanedValue ? true : false;
	} catch (e) {
		barcodeScannedValueFound = false;
	}
	if (!barcodeScannedValueFound) {
		formik.setFieldValue('Barcode', '');
		Swal.fire(strings.ErrorTitle, strings.BarcodeFormat, 'error');
	}
	if (barcodeScannedValueFound) {
		let aiValues = scanedValue.parsedCodeItems;
		let gTinNo = aiValues.filter(function (e) { return e.ai === consts.BarcodeApplicationIdentifier.TinNo; });
		let expiryDate = aiValues.filter(function (e) { return e.ai === consts.BarcodeApplicationIdentifier.ExpiryDate });
		let lotOrBatchNo = aiValues.filter(function (e) { return e.ai === consts.BarcodeApplicationIdentifier.LotOrBatchNo });

		if (lotOrBatchNo.length > 0) {
			formik.setFieldValue('LotNumber', lotOrBatchNo[0].data, true);
		}

		if (expiryDate.length > 0) {
			expiryDate = expiryDate[0].data;
			if (new Date() < expiryDate) {
				formik.setFieldValue('ExpiryDate', dayjs(expiryDate).format(consts.MomentFormat.DateTimeFormat), true);
			}
			else {
				Swal.fire(strings.Info, strings.UniqueProductIdentifierIsExpiredAndShouldNotBeUsed, 'info');
			}
		}

		if (gTinNo.length > 0) {
			let gTinValue = gTinNo[0].data.slice(2, -1);
			let indicatorCombo = activeRecord.combos ? activeRecord.combos.Indicator : null;
			let data = util.getDataFromValue(indicatorCombo, gTinValue, "GTIN");
			if (data) {
				formik.values.IndicatorId = data?.LookupId;
			}
			formik.values.GTIN = gTinValue;
			formik.setFieldValue('GTIN', gTinValue, true);
		}
	}
}

const isNeedToShow = () => {
	const { auth } = dataStore.getState()
	const RoleName = auth?.tags?.RoleName;
	return !['supervisor'].includes(RoleName?.toLowerCase());
}

const model = new Model({
	name: 'LotDetail',
	gridTitle: 'IndicatorLotDetail',
	defaultSort: 'IndicatorName',
	formTitleField: 'IndicatorName',
	readOnly: viewOnly,
	disableAdd: viewOnly,
	disableExport: viewOnly,
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true,
	},
	customizeSaveData: (data) => {
		data.ExpiryDate = dayjs(data.ExpiryDate).format('YYYY-MM-DD');
		return data;
	},
	formGroups: [{ fields: ['Barcode', 'GTIN', 'IndicatorId', 'LotNumber', 'ExpiryDate', 'IsActive'] }],
	columns: [
		{ header: 'UniqueId', field: 'LotDetailId', width: 120, hidden: true },
		{
			field: 'IndicatorName',
			header: 'IndicatorName',
			width: 180,
			formField: 'IndicatorId',
			lookup: 'Indicator',
			required: true,
			editable: ({ formik }) =>
				isNeedToShow() && `/indicatorlist?id=${formik.values.IndicatorId}&returnTo=/lotdetaillist?id=${formik?.values?.id || 'new'}`,
			addable: ({ formik }) =>
				isNeedToShow() && `/indicatorlist?id=new&returnTo=/lotdetaillist?id=${formik?.values?.id || 'new'}`
		},
		{ field: 'IndicatorType', width: 130, isNotformfield: true },
		{ field: 'LotNumber', header: 'LotNumber', width: 120, maxLength: 50, required: true },
		{
			field: 'Barcode', width: 400, type: 'string', onBlur: processBarcodeDetail, maxLength: 250
		},
		{ header: 'UniqueProductIdentifier', field: 'GTIN', width: 220 },
		{
			header: 'ExpiryDate',
			field: 'ExpiryDate',
			type: 'date',
			width: 140,
			required: true,
			isLocal: true,
			skipTime: true
		},
		{ header: 'Active', field: 'IsActive', type: 'boolean', width: 120 }
	]
});

export default model.createFormBase();